import React, { Component } from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import { FormattedHTMLMessage } from 'react-intl';
import './styles.css';

class HeaderItem extends Component {
	render() {
		const { label, variable, unit } = this.props;
		return (
			<div className="production-fixed-costs-layout-header-item">
				<div>
					<FormattedHTMLMessage id={label} />
				</div>
				<div>
					{numeral(variable.value).format('0,0')} {unit}
				</div>
			</div>
		);
	}
}

HeaderItem.propTypes = {
	label: PropTypes.string,
	variable: PropTypes.object,
	unit: PropTypes.string
};

export default HeaderItem;
